import React, { useContext, useState } from 'react'
import { SectionHeader, Text, Header2, Header3 } from '../../styles/Components'
import Input from '../Input'
import { gsColors } from '../../styles/Variables'
import GiftCardContext from './GiftCardContext'
import { validateGiftCardPurchase } from '../../helpers/validateGiftCardPurchase'
import { useUserContext } from '../UserContext'
import 'react-datepicker/dist/react-datepicker.css'
import { useRouter } from 'next/router'
import SelectProductButton from '../SelectProductButton'

import CalendarDropdown from '../CalendarDropdown'

const RecipientInfo = React.forwardRef(({ selectedMarket }, ref) => {
  const [calendarOpen, setCalendarOpen] = useState(false)
  const router = useRouter()
  const { user } = useUserContext()

  const toggleCalendar = () => setCalendarOpen((o) => !o)

  const {
    state: {
      giftOption,
      recipientFirst,
      recipientLast,
      recipientEmail,
      occasion,
      personalMessage,
      deliveryMethod,
      deliveryDate,
      selectedProduct,
      giftCardPrice,
      giftCardObject,
      deliveryDateUpdated,
      recipientFirstError,
      recipientLastError,
      recipientEmailError,
      deliveryMethodError,
      deliveryDateError,
      giftCardObjectError,
    },
    dispatch,
  } = useContext(GiftCardContext)

  const handleChange = (e) => {
    dispatch({
      type: 'EDIT_RECIPIENT_INFO',
      field: e.target.name,
      text: e.target.value,
    })
  }

  const handleSubmit = () => {
    validateGiftCardPurchase(
      giftOption,
      giftCardPrice,
      occasion,
      personalMessage,
      recipientFirst,
      recipientLast,
      recipientEmail,
      deliveryMethod,
      deliveryDate,
      deliveryDateUpdated,
      selectedProduct,
      giftCardObject,
      user,
      router,
      ref,
      selectedMarket,
      dispatch
    )
  }

  const showSection =
    (giftOption === 'gift-card' &&
      !!giftCardPrice &&
      !!Number(giftCardPrice.price) &&
      !!occasion) ||
    (giftOption === 'package' && !!selectedProduct)

  const step = giftOption === 'gift-card' ? '3' : '4'

  return (
    <div
      ref={ref}
      className={`recipient-info-container ${!showSection ? '_hide' : ''}`}
      data-testid="gift-card-recipient-container"
    >
      <SectionHeader margin="0 0 9px 0" small>
        Step {step}
      </SectionHeader>
      <Header2 margin="0 0 56px 0">Add recipient details</Header2>
      <div className="recipient-form">
        <Input
          autoComplete="new-password"
          placeholder="First Name"
          name="recipientFirst"
          onChange={handleChange}
          value={recipientFirst}
          error={recipientFirstError}
        />
        {recipientFirstError && (
          <Text
            margin="-16px 0 0"
            variant="small"
            color={gsColors.sunsetOrange}
          >
            Please enter a first name
          </Text>
        )}
        <Input
          autoComplete="new-password"
          name="recipientLast"
          onChange={handleChange}
          placeholder="Last Name"
          value={recipientLast}
          error={recipientLastError}
        />
        {recipientLastError && (
          <Text
            margin="-16px 0 0"
            variant="small"
            color={gsColors.sunsetOrange}
          >
            Please enter a last name
          </Text>
        )}
        <Input
          autoComplete="new-password"
          name="recipientEmail"
          onChange={handleChange}
          placeholder="Email Address"
          value={recipientEmail}
          error={recipientEmailError}
        />
        {recipientEmailError && (
          <Text
            margin="-16px 0 0"
            variant="small"
            color={gsColors.sunsetOrange}
          >
            Please enter a valid email address
          </Text>
        )}
      </div>
      <div className="recipient-delivery">
        <Header3 fontSize={18} margin="53px 0 25px">
          How would you like it delivered?
        </Header3>
        <div className="delivery-buttons">
          {['Email', 'Print'].map((d, i) => (
            <button
              key={i}
              className={
                deliveryMethod && deliveryMethod === d ? 'selected' : ''
              }
              onClick={() =>
                dispatch({
                  type: 'SET_DELIVERY_METHOD',
                  deliveryMethod: d,
                })
              }
            >
              {d}
            </button>
          ))}
        </div>
        {deliveryMethodError && (
          <Text variant="small" color={gsColors.sunsetOrange} margin="8px 0 0">
            Please select a delivery method
          </Text>
        )}
        {deliveryDateError && (
          <Text variant="small" color={gsColors.sunsetOrange} margin="8px 0 0">
            Please select a delivery date
          </Text>
        )}
        {deliveryMethod === 'Print' && (
          <Text variant="small" color={gsColors.paleSlate} margin="8px 0 0">
            We&apos;ll email you a gift receipt of your purchase to print and
            give to your recipient.
          </Text>
        )}
        {deliveryMethod === 'Email' && (
          <div>
            <Text
              margin="8px 0 0"
              variant="small"
              color={gsColors.paleSlate}
              className="email-date-picker-text"
            >
              Choose when you&apos;d like it sent. Today&apos;s date will send
              immediately.
            </Text>
            <CalendarDropdown 
              open={calendarOpen}
              date={deliveryDate}
              toggle={toggleCalendar}
              onClick={(date) => {
                dispatch({ type: 'SET_DELIVERY_DATE', date })
                setCalendarOpen(false)
              }}
            />
          </div>
        )}

        <SelectProductButton 
          product={true}
          onClick={handleSubmit}
          style={{ margin: '60px 0 0'}}
        />

        {giftCardObjectError && (
          <Text variant="small" color={gsColors.sunsetOrange} margin="8px 0 0">
            There was an error fetching gift-card data. Please refresh and try
            again.
          </Text>
        )}
      </div>
    </div>
  )
})

export default RecipientInfo
